module.exports = __webpack_public_path__ + "static/media/header1980.31b13d41.jpg";